import { AdditionalWidgetData } from "@/types/additional-widget-data";
import { TimeSeriesTable } from "@/features/shared/widgets/components";
import { WarningColors } from "@/features/shared/widgets/types";
import { useDashboardData } from "@/features/shared/hooks";
import useRefetchWidget from "@/features/shared/widgets/hooks/useRefetchWidget";

type Props = {
  id: string;
  data: AdditionalWidgetData;
};

const getColorCodeForValue = (value: number | string) => {
  if (value === "green") return WarningColors.SUCCESS;
  if (value === "yellow") return WarningColors.WARNING;
  if (value === "orange") return WarningColors.INFO;
  if (value === "red") return WarningColors.ERROR;
  return WarningColors.NONE;
};

const TextCode = ({ id, data }: Props) => {
  const { selectedTimeRange } = useDashboardData();

  useRefetchWidget(id);

  return (
    <TimeSeriesTable
      timeRange={selectedTimeRange}
      getColorCodeForValue={getColorCodeForValue}
      alwaysShowValues
      series={data.data}
    />
  );
};

export default TextCode;
